<script setup>
import {ref} from 'vue';
import Card from "primevue/card";
import Button from 'primevue/button';
import ContractsTable from "@/components/contract/ContractsTable.vue";
import DefaultLayout from '../../layouts/default.vue'
import InputText from "primevue/inputtext";
import InputIcon from "primevue/inputicon";
import IconField from "primevue/iconfield";
import ActiveArchiveToggle from '@/components/common/ActiveArchiveToggle.vue'
import contractApi from '@/api/contractApi.js';
import ContractForm from '@/components/contract/ContractForm.vue';
import { useRoute, useRouter } from 'vue-router';
import { usePermissions } from '@/composables/usePermissions.js';


const search = ref('');
const checked = ref(true); // true = активные, false = архив
const route = useRoute();
const router = useRouter();
const activeCount = ref(null);
const archiveCount = ref(null);
const { hasPermission } = usePermissions();

// Подсчёт активных/архивных в текущей выборке
async function fetchContractCounts({ q }) {
  const [activeResp, archiveResp] = await Promise.all([
    contractApi.getContracts({ page: 1, q, status: 'ACTIVE' }),
    contractApi.getContracts({ page: 1, q, status: 'ARCHIVED' }),
  ]);
  return {
    active: Number(activeResp?.count ?? 0),
    archive: Number(archiveResp?.count ?? 0)
  };
}

async function fetchArchiveCountOnly({ q }) {
  const archiveResp = await contractApi.getContracts({ page: 1, q, status: 'ARCHIVED' });
  return Number(archiveResp?.count ?? 0);
}

const showCreateDialog = ref(false);

// Предзагрузка facility из query (?facility=ID), если понадобится вызывать из Объекта
const presetFacilityId = ref(route.query?.facility ? Number(route.query.facility) : null);

function openCreate() {
  showCreateDialog.value = true;
}
function onCreated(contract) {
  // после создания — переходим в детали договора
  if (contract?.id) {
    router.push(`/contracts/${contract.id}`);
  }
}

function handleInitialCountLoaded({ count, isActive }) {
  if (isActive === true) {
    activeCount.value = count;
  } else if (isActive === false) {
    archiveCount.value = count;
  }
}

</script>
<template>
  <DefaultLayout>
    <Card class="w-full flex-1 flex flex-col min-h-0"
          :pt="{
            body: { class: 'flex-1 flex flex-col h-full' },
            content: { class: 'p-0 flex-1 flex flex-col min-h-0' }
          }"
    >
      <template #title>
        <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-8">
          <IconField>
            <InputIcon class="pi pi-search" />
            <InputText v-model="search" placeholder="Поиск договора..."/>
          </IconField>
            <ActiveArchiveToggle
                v-if="hasPermission('contract.archive_contract')"
                v-model="checked"
                :search="search"
                :initial-active-count="activeCount"
                :initial-archive-count="archiveCount"
                :skip-initial-load="true"
                :fetchCounts="fetchContractCounts"
                :fetchArchiveCountOnly="fetchArchiveCountOnly"
                onIcon="pi pi-sun"
                offIcon="pi pi-moon"
                widthClass="w-36"
                ariaLabel="Фильтр по активности договоров"
            />
          </div>
            <Button
                v-if="hasPermission('contract.add_contract')"
                label="Добавить договор"
                icon="pi pi-plus"
                severity="info"
                rounded
                @click="openCreate"
            />
          </div>
      </template>

      <template #content>
        <ContractsTable :search="search" :is-active="checked" @initial-count-loaded="handleInitialCountLoaded" />
      </template>
    </Card>
    <ContractForm
        v-model:visible="showCreateDialog"
        :preset-facility-id="presetFacilityId"
        @created="onCreated"
    />
  </DefaultLayout>
</template>

<style scoped />